import { Component, OnInit } from '@angular/core';
import { ShoppingService } from '../../core/services/shopping.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HelperService } from '../../core/services/helper.service';
import { appVariables, appApiResources } from '../../core/constants/Common.constant';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-add-item-using-email',
  templateUrl: './add-item-using-email.component.html',
  styleUrls: ['./add-item-using-email.component.css']
})
export class AddItemUsingEmailComponent implements OnInit {
  BackToPageUrl = '';
  constructor(private shoppingService: ShoppingService, private router: Router,
    private helperService: HelperService, private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.helperService.startLoader();
    this.shoppingService.observeBackToPageUrl.subscribe(appurl => {
      this.BackToPageUrl = appurl;
    });
    this.activatedRoute.queryParams.subscribe(params => {
      this.helperService.signOutUser();
      const productid = params['productid'];
      const appID = params['applicationid'];
      const email = params['email'];
      const emailnumber = params['emailnumber'];
      const promoCode = params['promoCode'];
      if (appID) {
        this.helperService.setToLocalStorage(appVariables.accessAppID, appID);
      }
      if (promoCode) {
        this.helperService.setToLocalStorage(appVariables.promoCode, promoCode);
      }
      if (productid) {
        this.shoppingService.AddShoppingCartItemsByLink(productid, promoCode, email, emailnumber, appID)
          .subscribe(
            (response) => {
              // tslint:disable-next-line:no-debugger
              if (!response.Error) {
                this.helperService.setToLocalStorage(appVariables.accessTokenLocalStorage, response.Data);

                const url = environment.ShoppingCartUrl + appApiResources.cartUrl + '?appID=' + appID + '&GUID=' + response.Data;

                window.location.href = url;
                // this.router.navigate([appApiResources.cartUrl2, { queryParams: { appID: appID, token: response.Data } }],
                // { relativeTo: this.activatedRoute });
              } else {
                // this.Errors = response.Error;
                this.helperService.stopLoader();
                this.helperService.backToSite(this.BackToPageUrl);
              }
            },
            (error) => {
              this.helperService.stopLoader();
              this.helperService.backToSite(this.BackToPageUrl);
              // this.Errors = JSON.parse(error._body).Error; // [appMessages.CommonError];
            }
          );
      }
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/shoppingcart/add-item-using-email/add-item-using-email.component.ts